import {createPatchscriptFromTemplate} from '@pos-refacto/patchscript-with-react'

/**
 * @deprecated Use `createPatchscriptFromTemplate` from `@pos-refacto/patchscript-with-react` directly
 */
export const composeReceiptWithSchema = createPatchscriptFromTemplate;
